export const aliasRoles = [
    {received: 'ROLE_USER', display: 'Usuário comum'},
    {received: 'ROLE_ADMIN', display: 'Usuário administrador'},
    {received: 'ROLE_GROUP_LEADER', display: 'Usuário Gerenciador de Grupos'},
    {received: 'ROLE_FUNDO', display: 'Fundo Investidor'},
    {received: 'ROLE_PARCEIRO_COMERCIAL', display: 'Parceiro Comercial'}
]
